export enum SocialMediaGalleryType {
    google = 1,
    instagram = 3,
    linkedin = 4,
    googleMyBusiness = 5,
}
